var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"box"}},[_c('div',{staticClass:"inner"},[_c('h1',{domProps:{"innerHTML":_vm._s('xID APP')}}),_c('div',{staticClass:"wrapper"},[_c('CustomButton',{attrs:{"isSingle":true,"buttonType":'primary',"customButtonTxt":'Launch xID app'},on:{"submit":_vm.directAPP}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }